import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import ChangeCard from "./changecard.component";
import ls from 'local-storage';
export default class ChangeCardDetails extends Component {	
	
	componentDidMount(){
		document.title = "CONQER Music - Listener Registration";
		ls.set('registration_type', '');
		ls.set('registration_type', this.props.match.params.type);
	}
	
    render() { return (<ChangeCard />)}
}